import { GalleryDetailModal } from '@/features/gallery/components/GalleryDetailModal';
import { GalleryUploadModal } from '@/features/gallery/components/GalleryUploadModal';
import { galleryItemId } from '@/features/gallery/types/gallery';
import { useGalleryPage } from './useGalleryPage';
import { GalleryHeader } from './sections/GalleryHeader';
import { GalleryStatusTabs } from './sections/GalleryStatusTabs';
import { GalleryGrid } from './sections/GalleryGrid';
import { GalleryPagination } from './sections/GalleryPagination';
import { DeleteConfirmModal } from './sections/DeleteConfirmModal';

export function GalleryPage() {
  const {
    canUpload,
    canDelete,
    filter,
    setStatus,
    setPage,
    uploadOpen,
    setUploadOpen,
    detailItem,
    setDetailItem,
    deleteItem,
    setDeleteItem,
    items,
    totalPages,
    totalItems,
    counts,
    rangeLabel,
    isListPending,
    deleteMutation,
  } = useGalleryPage();

  return (
    <div className="mx-auto flex w-full max-w-6xl flex-col gap-5">
      <GalleryHeader canUpload={canUpload} onUpload={() => setUploadOpen(true)} />

      <GalleryStatusTabs status={filter.status} counts={counts} onSelect={setStatus} />

      <GalleryGrid
        isPending={isListPending}
        items={items}
        status={filter.status}
        canDelete={canDelete}
        onViewDetail={setDetailItem}
        onDelete={setDeleteItem}
      />

      {totalPages > 1 || totalItems > 0 ? (
        <GalleryPagination
          page={filter.page}
          totalPages={totalPages}
          isPending={isListPending}
          rangeLabel={rangeLabel}
          onPageChange={setPage}
        />
      ) : null}

      <GalleryUploadModal open={uploadOpen} onClose={() => setUploadOpen(false)} />
      <GalleryDetailModal item={detailItem} onClose={() => setDetailItem(null)} />

      <DeleteConfirmModal
        item={deleteItem}
        isDeleting={deleteMutation.isPending}
        onCancel={() => setDeleteItem(null)}
        onConfirm={() => {
          if (!deleteItem) return;
          const id = galleryItemId(deleteItem);
          if (!id) return;
          deleteMutation.mutate(id, {
            onSuccess: () => {
              setDeleteItem(null);
              setDetailItem(null);
            },
          });
        }}
      />
    </div>
  );
}
